import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, BatteryWarning, BrainCircuit } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  const painPoints = [{
    icon: Clock,
    text: 'Preparar clases'
  }, {
    icon: BrainCircuit,
    text: 'Improvisar'
  }, {
    icon: AlertCircle,
    text: 'Corregir y Evaluar'
  }, {
    icon: BatteryWarning,
    text: 'Contener y Motivar'
  }];
  return <section className="py-12 bg-orange-50" data-id="element-83">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-86">
            Si sos docente de inglés y sentís que cada semana vivís corriendo...
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-8" data-id="element-87">
            Improvisando y agotada, no es que seas mala docente. No es que te
            falte vocación. No es que no sepas enseñar.
          </p>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-orange-100 inline-block" data-id="element-88">
            <p className="text-2xl font-bold text-orange-600" data-id="element-89">
              👉 Te falta un sistema que te sostenga.
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-90">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-91">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-92">
              Porque hoy, planificar no es planificar. Es sobrevivir.
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-93">
              Buscás actividades a último momento. Imprimís apurada. Explicás
              sin estructura. Te llevás trabajo todos los días.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-94">
              Y entrás al aula con una sensación que no te deja tranquila:
            </p>
            <blockquote className="border-l-4 border-orange-500 pl-4 italic text-gray-600 text-lg mb-6" data-id="element-95">
              "Ojalá esto salga bien..."
            </blockquote>
            <p className="font-semibold text-gray-900" data-id="element-96">
              No estás cansada. Estás sobrecargada. <br data-id="element-97" />
              No estás fallando. Estás enseñando sin un sistema que te proteja.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-98">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center uppercase tracking-wider" data-id="element-99">
              El problema real no es tuyo
            </h3>
            <p className="text-gray-600 mb-6 text-center" data-id="element-100">
              El sistema educativo te pide que hagas el trabajo de 3 personas…
              con el tiempo de una.
            </p>

            <div className="grid grid-cols-2 gap-4" data-id="element-101">
              {painPoints.map((point, idx) => <div key={idx} className="flex flex-col items-center p-3 bg-gray-50 rounded-lg" data-id="element-102">
                  <point.icon className="w-6 h-6 text-orange-500 mb-2" data-id="element-103" />
                  <span className="text-sm font-medium text-gray-700 text-center" data-id="element-104">
                    {point.text}
                  </span>
                </div>)}
            </div>

            <p className="mt-6 text-center text-gray-500 text-sm italic" data-id="element-105">
              Y ahí empieza el desgaste invisible: mental, emocional,
              silencioso.
            </p>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-106">
          <CTAButton text="NECESITO UNA SOLUCIÓN" data-id="element-107" />
        </div>
      </div>
    </section>;
}